import React from 'react';
import { setCategory } from '../../../store/categories';
import { sections } from '../../../utils/data/shop';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
// import Image from 'next/image';

function CategoryNavSection({
  categoryName,
  title,
  imgUrl,
  innerText,
  reversed = false
}) {
  const categories = useSelector(state => state.categories.categories);
  const dispatch = useDispatch();
  const router = useRouter();

  const category = categories.find(item => item.name === categoryName);
  const query = router.query;

  return (
    <div
      className={`row category-nav-container  ${
        reversed ? 'flex-row-reverse category-nav' : ''
      }`}
    >
      <div className={'col-md-7 p-0'}>
        <figure className={'m-0 pict-size'}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            alt="furniture"
            // height={512}
            // loading={'lazy'}
            src={imgUrl}
            // width={1350}
          />
        </figure>
      </div>
      <div className={'col-md-5 category-nav-msg-container'}>
        <span className={'nav-msg-title'}>{title}</span>
        <span className={'nav-msg-text'}>{innerText}</span>
        <button
          className={'btn cat-nav-btn'}
          onClick={() => {
            dispatch(setCategory(category));
            router.push({
              pathname: '/shop',
              query: {
                ...query,
                filters: JSON.stringify({
                  [sections.categories]: [category?.name],
                  [sections.price]: { min: 0, max: 0 },
                  [sections.materials]: [],
                  [sections.colors]: []
                })
              }
            });
          }}
        >
          Shop now
        </button>
      </div>
    </div>
  );
}

export default React.memo(CategoryNavSection);
